import { secondsToMilliseconds } from 'date-fns';
import { useCallback } from 'react';

import { toast } from '../../toasts';
import { ClientTranscriptionConsentToast } from './ClientTranscriptionConsentToast';

const CLIENT_TRANSCRIPTION_RESPONSE_TOAST_KEY = 'client-transcription-response-toast';

export function useClientTranscriptionResponseToastCallback() {
  return useCallback((isOptIn: boolean) => {
    toast.enqueue((ariaProps) => <ClientTranscriptionConsentToast {...ariaProps} isOptIn={isOptIn} />, {
      key: CLIENT_TRANSCRIPTION_RESPONSE_TOAST_KEY,
      timeout: secondsToMilliseconds(30),
    });
  }, []);
}
